import { gsap, Cubic } from "gsap";
export default class Tabs {
  constructor() {
    this.contents = document.querySelector('.products-storeitems');

    this.tabList = this.contents.querySelector('.products-storeitems__tabs')
    this.tabs = this.contents.querySelectorAll('._tab:not([disabled="true"])');
    this.lists = this.contents.querySelectorAll('.products-storeitems__list');

    this.setup()
  }

  setup () {
    for (let i = 0; i < this.tabs.length; i++) {
      this.tabs[i].addEventListener('click', (event) => {
        let list = this.contents.querySelector(this.tabs[i].dataset.open)
        this.remove();
        this.tabs[i].classList.add("on");
        this.tabs[i].setAttribute('aria-selected', 'true');
        this.tabs[i].setAttribute('tabindex', '0');
        list.classList.remove("off");
        this.fadein(list);
      });
    }

    this.contents.querySelectorAll(".c-card").forEach((elm, index) => {
      gsap.set(elm, {opacity: 0});
    });

    //一つ目のタブを選択
    this.tabs[0].click();

    this.handleTabsNavigation()
  }

  remove() {
    for (let i = 0; i < this.tabs.length; i++) {
      this.tabs[i].classList.remove("on");
      this.tabs[i].setAttribute('aria-selected', 'false');
      this.tabs[i].setAttribute('tabindex', '-1');
    }
    for (let i = 0; i < this.lists.length; i++) {
      this.lists[i].classList.add("off");
    }
  }

  fadein(elm) {
    elm.querySelectorAll(".c-card").forEach((elm, index) => {
      gsap.fromTo(
        elm,
        {
          opacity: 0
        },
        {
          opacity: 1,
          duration: 1.5,
          delay: 0.06 * index,
          ease: Cubic.easeOut
        }
      );
    });
  }

  handleTabsNavigation() {
    const selectFirstTab = () => {
      selectTab(0);
    }

    const selectLastTab = () => {
      selectTab(this.tabs.length - 1);
    }

    const selectTab = (index) => {
      this.tabs.forEach(function(tab) {
        tab.setAttribute('aria-selected', false);
        tab.setAttribute('tabindex', -1);
      });

      this.tabs[index].setAttribute('aria-selected', true);
      this.tabs[index].setAttribute('tabindex', 0);
      this.tabs[index].focus();
      this.tabs[index].click();

      this.lists.forEach(function(tabpanel) {
        tabpanel.classList.remove('on');
      });

      const nextTabPanel = document.querySelector('#' + this.tabs[index].getAttribute('aria-controls'));
      nextTabPanel.classList.add('on');
    }

    const selectPreviousTab = () => {
      const activeTab = this.contents.querySelector('._tab[aria-selected="true"]');
      const activeTabIndex = Array.prototype.slice.call(this.tabs).indexOf(activeTab);

      if(activeTabIndex > 0) {
        selectTab(activeTabIndex - 1);
      } else {
        selectTab(this.tabs.length - 1);
      }
    }

    const selectNextTab = () => {
      const activeTab = this.contents.querySelector('._tab[aria-selected="true"]');
      const activeTabIndex = Array.prototype.slice.call(this.tabs).indexOf(activeTab);

      if(activeTabIndex < this.tabs.length - 1) {
        selectTab(activeTabIndex + 1);
      } else {
        selectTab(0);
      }
    }

    this.tabList.addEventListener('keydown', function(e) {
      switch(e.key) {
        case 'ArrowLeft':
          selectPreviousTab();
          break;

        case 'ArrowRight':
          selectNextTab();
          break;

        case 'Home':
          e.preventDefault()
          selectFirstTab();
          break;

        case 'End':
          e.preventDefault();
          selectLastTab();
          break;
      }
    });
  }
}
